import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;

  > span {
    margin-left: 28px;
    color: ${({ theme }) => theme.colors.grey[200]};

    @media ${({ theme }) => theme.devices.mobile} {
      margin-left: 12px;
      font-size: 12px;
    }
  }
`;

export const StyledLink = styled.a`
  width: 100%;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  img {
    display: ${({ $loading }) => ($loading ? 'none' : 'block')};
    width: 100%;
  }
`;

export const Skeleton = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.grey[700]} 0%,
    ${({ theme }) => theme.colors.grey[600]} 20%,
    ${({ theme }) => theme.colors.grey[700]} 40%,
    ${({ theme }) => theme.colors.grey[700]} 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 2s ease infinite;
`;

export const Error = styled.div`
  width: 100%;
  margin-top: 20px;

  span {
    color: ${({ theme }) => theme.colors.outher.danger};
  }
`;
